export default function livewire({ setTableColor, setSrcFromDataSrc, moveElementBottom, addLoader, removeLoader, animationSizeItemsNotAllowed }) {
    document.addEventListener('livewire:init', () => {

        /**
         * Livewire closing modal compare
         */
        const compareModal = document.querySelector('#compareModal .btn-close');
        if (compareModal) {
            Livewire.on('livewire-close-modal-compare', () => {
                compareModal.click();
                setTableColor();
            });
        }

        /**
         * Livewire setting active compare row to change product
         */
        const compareProductChangeBtns = document.querySelectorAll('.compare__product-change');
        if (compareProductChangeBtns.length) {
            compareProductChangeBtns.forEach(btn => {
                btn.classList.remove('active-compare');
                btn.addEventListener('click', function () {
                    document.querySelector('.active-compare')?.classList.remove('active-compare');
                    if (!btn.classList.contains('active-compare')) {
                        btn.classList.add('active-compare');
                    }
                });
            });
        }

        /**
         * Livewire change compare product to active row
         */
        const compareProductChangeModal = document.querySelectorAll('.compare-modal__product-label');
        if (compareProductChangeModal.length) {
            compareProductChangeModal.forEach(btn => {
                btn.addEventListener('click', function () {
                    const positionTochange = document.querySelector('.active-compare')?.dataset.index;
                    const skuToInsert = btn?.dataset.sku;
                    if (skuToInsert && positionTochange) {
                        Livewire.emit('positionToChange', [positionTochange, skuToInsert]);
                    }
                });
            });
        }

        /**
         * Livewire render after page changing (stories and athletes)
         */
        Livewire.on('livewire-change-pagination', () => {
            const storyCardImages = document.querySelectorAll('.story-card img');
            if (storyCardImages.length) setSrcFromDataSrc(storyCardImages);

            const athleteCardImages = document.querySelectorAll('.athlete-card img');
            if (athleteCardImages.length) setSrcFromDataSrc(athleteCardImages);
        });

        /**
         * Livewire render after changes in product detail page
         */
        Livewire.on('livewire-reload-lazy-product-page', () => {
            const compareModalProductImages = document.querySelectorAll('.compare-modal__product-image img');
            if (compareModalProductImages.length) setSrcFromDataSrc(compareModalProductImages);

            const compareProductImages = document.querySelectorAll('.compare__product-figure img');
            if (compareProductImages.length) setSrcFromDataSrc(compareProductImages);
        });

        /**
         * Livewire product change variant
         */
       Livewire.on('livewire-reload-swiper', () => {
            moveElementBottom();
            setTableColor();
            setTimeout(() => animationSizeItemsNotAllowed(), 1000);
        });
    });
}
